export const toUrl = (...params) => {
  const string = params.join("/")
  if (!string) {
    return "/"
  }

  return `/${string}/`.replace(/\/+/g, "/")
}
